var _path, _g, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33437_4403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000244141 0.0115967H17.0529V19.8651H0.000244141V0.0115967Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33437_4403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57335 1.5116C2.91635 1.5116 1.54035 2.8536 1.50135 4.5086V15.2036C1.46435 16.9166 2.81435 18.3276 4.51035 18.3656H12.5743C14.2433 18.2966 15.5653 16.9096 15.5533 15.2096V6.3396L10.9183 1.5116H4.58535H4.57335ZM4.58535 19.8656H4.47635C1.95435 19.8086 -0.0536524 17.7106 0.00134757 15.1876V4.4906C0.0593476 2.0096 2.10835 0.0115967 4.57135 0.0115967H4.58835H11.2383C11.4423 0.0115967 11.6373 0.0945967 11.7793 0.241597L16.8443 5.5186C16.9783 5.6576 17.0533 5.8446 17.0533 6.0376V15.2036C17.0713 17.7126 15.1173 19.7626 12.6043 19.8646L4.58535 19.8656Z",
    fill: "currentColor"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2985 6.98424H13.5435C11.7135 6.97924 10.2255 5.48724 10.2255 3.65924V0.750244C10.2255 0.336244 10.5615 0.000244141 10.9755 0.000244141C11.3895 0.000244141 11.7255 0.336244 11.7255 0.750244V3.65924C11.7255 4.66324 12.5425 5.48124 13.5455 5.48424H16.2985C16.7125 5.48424 17.0485 5.82024 17.0485 6.23424C17.0485 6.64824 16.7125 6.98424 16.2985 6.98424Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7887 14.1084H5.38867C4.97467 14.1084 4.63867 13.7724 4.63867 13.3584C4.63867 12.9444 4.97467 12.6084 5.38867 12.6084H10.7887C11.2027 12.6084 11.5387 12.9444 11.5387 13.3584C11.5387 13.7724 11.2027 14.1084 10.7887 14.1084Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7437 10.3563H5.3877C4.9737 10.3563 4.6377 10.0203 4.6377 9.60632C4.6377 9.19232 4.9737 8.85632 5.3877 8.85632H8.7437C9.1577 8.85632 9.4937 9.19232 9.4937 9.60632C9.4937 10.0203 9.1577 10.3563 8.7437 10.3563Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.9190662e87dbad7d96b4e5e38db6095e.svg";
export { ForwardRef as ReactComponent };